<div class="pme-container">
  <pme-hero *ngIf="this.selfAttendanceHeroData" type="error" title="{{this.selfAttendanceHeroData.title}}">
      <p *ngFor="let content of this.selfAttendanceHeroData.contents" [innerHtml]="content"></p>
    </pme-hero>
  <main class="d-flex-row flex-wrap main" *ngIf="!this.selfAttendanceHeroData">
      <div class="form-container">
        <div class="form-header">
          <p class="header-title">Renovação</p>
          <p class="header-text">Escolha como você deseja realizar o pagamento da renovação do seu plano. Utilizaremos
            estes
            dados para as futuras cobranças.</p>
          <!-- <div class="header-card">
                  <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.66309 1.50407H15.6133C16.3002 1.50407 16.9584 1.77705 17.4326 2.25114L32.1494 16.9679C33.1756 17.9942 33.1707 19.6195 32.166 20.6242L20.2168 32.5734C19.2097 33.5805 17.5677 33.5805 16.5605 32.5734L1.83691 17.8498L1.66504 17.6652C1.28809 17.2142 1.08008 16.6376 1.08008 16.0373V4.08708L1.09375 3.82439C1.21805 2.61378 2.18978 1.64204 3.40039 1.51775L3.66309 1.50407ZM2.91309 16.3478L18.3799 31.8146L31.3906 18.8039L15.9238 3.33708H2.91309V16.3478ZM7.83008 6.50407C8.79658 6.50407 9.58008 7.28758 9.58008 8.25407C9.58008 9.22057 8.79658 10.0041 7.83008 10.0041C6.86358 10.0041 6.08008 9.22057 6.08008 8.25407C6.08008 7.28758 6.86358 6.50407 7.83008 6.50407Z" fill="#0FAC67" stroke="#0FAC67" stroke-width="1.5"/>
                  </svg>
                  <p>Pague com o {{ this.paymentMethod }} <br><strong>e ganhe 20% na renovação</strong></p>
              </div> -->
        </div>
        <pme-payment-form *ngIf="this.showForm" [buttonName]="this.buttonName" [paymentOptions]="this.paymentOptions"
          [termOfUse]="this.termOfUse" [paymentChangeProduct]="this.currentProduct"
          [discountBadgeCreditCard]="this.discountBadgeCreditCard" [creditCardData]="this.creditCardData"
          [creditCardsData]="this.creditCardsData" [maxLimitCreditCards]="maxLimitCreditCards"
          [context]="'PAYMENT_CHANGE'" [hideConditions]="false"
          (paymentMethodSelected)="this.onPaymentMethodSelected($event)" (formSubmitted)="onPaymentChangePerform($event)"
          [paymentChangeMessage]="this.paymentChangeMessage" (deleteCreditCard)="handleDeleteCreditCard($event)">
        </pme-payment-form>
      </div>
      <aside class="product-info-card">
        <pme-renewal-info *ngIf="this.renewalInfo" [renewalInfo]="this.renewalInfo">
        </pme-renewal-info>
      </aside>
  </main>
</div>